module.exports = __webpack_public_path__ + "img/rank_bronze.cf04a879.png";